
// 即日発送締め切り時間
const limitHour = 12
const displayHour = 11
// 休日 (日付)
const holidayDate = [
  '2024/11/23',   //勤労感謝の日
  '2024/12/30',   //冬季休業
  '2024/12/31',   //冬季休業
  '2025/1/1',   //冬季休業
  '2025/1/2',   //冬季休業
  '2025/1/3',   //冬季休業
  '2025/1/4',   //調整
  '2025/1/13',   //成人の日
  '2025/2/11',   //建国記念の日
  '2025/2/24',   //天皇誕生日
  '2025/3/20',   //春分の日
  '2025/4/29',   //昭和の日
  '2025/5/3',   //憲法記念日
  '2025/5/4',   //みどりの日
  '2025/5/5',   //こどもの日
  '2025/5/6',   //振替休日
  '2025/7/21',   //海の日
  '2025/8/11',   //山の日
  '2025/9/15',   //敬老の日
  '2025/9/23',   //秋分の日
  '2025/10/13',   //スポーツの日
  '2025/11/3',   //文化の日
  '2025/11/23',   //勤労感謝の日
  '2025/11/24',   //振替休日  
]
  // 休日 (曜日)
  const holidayWeek = [
  '土',
  '日',
]
// 定休日を格納する
let shipDate = null
// ベースとなる日 (=今日)
const baseDate = new Date()
// 現在時刻
const hours = baseDate.getHours()

// 営業日 && 12時までの注文は当日出荷
if (!isHoliday(baseDate) && hours < limitHour) {
  shipDate = baseDate
} else {
  // 定休日を算出する
  do {
    // 1日ずつ加算
    baseDate.setDate(baseDate.getDate() + 1);
    // 休日でない場合
    if (!isHoliday(baseDate)) {
      shipDate = baseDate
    }
  } while (shipDate === null)
    }

    if (shipDate !== null) {
      // 注文日時
      // 年度を出す場合
     //document.getElementById('shipDate01').innerText = formatDate(shipDate, 'MM月DD日')
      if(document.getElementById("shipDate01") != null){
        document.getElementById('shipDate01').innerText = formatDate(shipDate, 'MM/DD')+" "+displayHour+":59"
      }
      // 出荷日をHTMLに反映
      // 年度を出す場合
    if(document.getElementById("shipDate02") != null){
     document.getElementById('shipDate02').innerText = formatDate(shipDate, 'MM/DD')
     //document.getElementById('shipDate02').innerText = formatDate(shipDate, 'MM月DD日')
    }
    if(document.getElementById("shipDate03") != null){
      document.getElementById('shipDate03').innerText = formatDate(shipDate, 'MM月DD日')
      document.getElementById('shipDate03').innerText = formatDate(shipDate, 'MM/DD')+" "+displayHour+":59"
    }
    if(document.getElementById("shipDate04") != null){
      //document.getElementById('shipDate04').innerText = formatDate(shipDate, 'MM月DD日')      
      document.getElementById('shipDate04').innerText = formatDate(shipDate, 'MM/DD')
      }
    }

  /**
   * 休日かどうか判定する
   * @return boolean
   */
  function isHoliday(date) {
    const week = date.getDay()
    const weekString = ['日', '月', '火', '水', '木', '金', '土' ][week]
    return holidayDate.includes(formatDate(date, 'YYYY/MM/DD'))
    || holidayWeek.includes(weekString)
  }

  /**
   * 日付をフォーマットする
   * @param date
   * @param format
   * @returns {*}
   */
  function formatDate(date, format) {
    format = format.replace(/YYYY/, date.getFullYear());
    format = format.replace(/MM/, date.getMonth() + 1);
    format = format.replace(/DD/, date.getDate());
    return format;
  }
